import { MOBILE_FEATURE_NAMES, MOBILE_FEATURES } from '@repo/core-api'

import { isMobile, isiOS, isMobileApp, getMobileAppVersion, isBrowser } from '@repo/utils'

export { isMobile, isiOS, isMobileApp, getMobileAppVersion }

export const canUseMobileFeature = (featureKey) => {
  const version = getMobileAppVersion()
  if (!version) return false
  const { minimumVersion, maximumVersion } = MOBILE_FEATURES[featureKey] ?? {}
  return (
    (!minimumVersion || version >= minimumVersion) &&
    (!maximumVersion || version <= maximumVersion)
  )
}

export const isUserAgentAvailable = () => {
  const windowAvailable = isBrowser()
  const isUserAgentAvailable = windowAvailable && window?.navigator?.userAgent
  return isUserAgentAvailable
}

export const sendSportsbookStatusEvent = (openBetsCount) => {
  return sendMobileAppEvent('sportsbookStatus', { openBetsCount })
}

/**
 *
 * @param {key that will be used with MOBILE_FEATURE_NAMES} featureKey
 * @returns Did it manage to send the event
 */
export const sendMobileAppEvent = (featureKey, body = {}) => {
  if (!MOBILE_FEATURE_NAMES[featureKey]) {
    console.error('Feature key does not exist!')
    return false
  }
  if (
    window.KTOMobileApp?.postMessage &&
    canUseMobileFeature(MOBILE_FEATURE_NAMES[featureKey])
  ) {
    window.KTOMobileApp?.postMessage(
      JSON.stringify({ event: MOBILE_FEATURE_NAMES[featureKey], ...body })
    )
    return true
  }
  return false
}

